import { useRouter as useNextRouter } from 'next/navigation';
import { useEffect, useTransition } from 'react';
import { useLoadingStore } from 'store/loadingStore';

export const useRouter = () => {
  const { setLoading } = useLoadingStore();
  const router = useNextRouter();
  const [isPending, startTransition] = useTransition();

  const pushWithLoader = (url) => {
    setLoading(true); // Start loading when the push begins
    startTransition(() => {
      router.push(url); // Perform the navigation
    });
    startTransition(() => router.refresh());
  };

  // Use the isPending state to stop loading once transition completes
  useEffect(() => {
    if (!isPending) {
      setLoading(false); // Stop loading when the transition is complete
    }
  }, [isPending, setLoading]);

  return {
    ...router,
    push: pushWithLoader,
  };
};
